import {getHostVariables} from '../utils';
import {COMPONENT_ID} from '../symbols';
import {removeMappings} from '../property-selectors';

export default function unstableRemoveRenderOnPropertySelectorValueChange(host, propertySelector) {
	const hostVariables = getHostVariables(host);
	removeMappings(hostVariables[COMPONENT_ID], propertySelector);
}
